const SET_PULSE_CHECK_COMMENT = 'SET_PULSE_CHECK_COMMENT';
const SET_STAR_RATING_VALUE = 'SET_STAR_RATING_VALUE';

/**
 * Called when the comment box on the additional feeback page
 * is filled out or updated.
 */
export const setPulseCheckComment = (comment) => {
    return {
        type: SET_PULSE_CHECK_COMMENT,
        comment
    };
};

/**
 * Called when one of the star rating buttons on the pulse
 * check page is clicked.
 */
export const setStarRatingValue = (rating) => {
    return {
        type: SET_STAR_RATING_VALUE,
        rating 
    };
};



// WEBPACK FOOTER //
// ./application/containers/PulseCheck/actions.js